import React, { ReactElement } from 'react';
import { Tooltip as AntTooltip, TooltipProps } from 'antd';

export const Tooltip = ({ overlayClassName, ...restProps }: TooltipProps): ReactElement => (
  <AntTooltip
    overlayClassName={['custom-ant-tooltip', overlayClassName].join(' ')}
    placement="right"
    color="rgba(0, 0, 0, 0.75)"
    {...restProps}
  />
);
